import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { FormFieldWrap } from '@zooplus/ui-components';
import FormMessages from '../FormMessages/FormMessages.js';
import styles from './FormControlWrapper.module.scss.js';

const FormControlWrapper = ({ children, labelInline = false, label, labelFor, infoMessageIcon, infoMessage, errorMessage, errorZta, }) => {
    return (jsxs(FormFieldWrap, { className: classNames(styles.formControlWrapper, {
            [styles.noLabelInput]: !label,
        }), columnWidths: labelInline ? ['15rem', 'calc(100% - 15rem)'] : undefined, labelText: label, labelFor: labelFor, children: [jsx("div", { className: classNames({ [styles.spacer]: !label }) }), jsxs("div", { children: [children, jsx(FormMessages, { infoMessage: infoMessage, errorMessage: errorMessage, infoMessageIcon: infoMessageIcon, errorZta: errorZta })] })] }));
};

export { FormControlWrapper as default };
//# sourceMappingURL=FormControlWrapper.js.map
